export default __webpack_public_path__ + "static/media/est-pc.ceed217e.webp";